import styled, { createGlobalStyle } from 'styled-components'

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 96px 16px;
    }
    .container-fluid {
      gap: 0;
    }
  }
`

export const ProgramTitle = styled.h2`
  font-size: 21px;
  font-weight: 700;
  color: #313131;
  margin: 0;
  font-family: 'Caixa Std', sans-serif;
`
